
import { useState } from 'react';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-lg fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <img 
                src="https://static.readdy.ai/image/9c863003ff2a45a7fdb4b616e355a476/83a4210232d56303cd212f2c5e8ac070.png" 
                alt="ProArk Haven Logo" 
                className="h-12 w-auto"
              />
            </div>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-orange-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-orange-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                About Us
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-orange-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('activities')}
                className="text-gray-700 hover:text-orange-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Activities
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="text-gray-700 hover:text-orange-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-orange-600 text-white px-6 py-2 rounded-full text-sm font-medium hover:bg-orange-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Schedule Tour
              </button>
            </div>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-orange-600 focus:outline-none cursor-pointer"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <button 
                onClick={() => scrollToSection('home')}
                className="block text-gray-700 hover:text-orange-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Home
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="block text-gray-700 hover:text-orange-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                About Us
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="block text-gray-700 hover:text-orange-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Services
              </button>
              <button 
                onClick={() => scrollToSection('activities')}
                className="block text-gray-700 hover:text-orange-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Activities
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block text-gray-700 hover:text-orange-600 px-3 py-2 text-base font-medium w-full text-left cursor-pointer"
              >
                Contact
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="block bg-orange-600 text-white px-3 py-2 text-base font-medium w-full text-left rounded-lg hover:bg-orange-700 transition-colors cursor-pointer"
              >
                Schedule Tour
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
